export const MENUWEBS_GET = 'MENUWEBS_GET';
export const MENUWEB_CATEGORYOPTS_GET = 'MENUWEB_CATEGORYOPTS_GET';
export const MENUWEB_PAGEOPTS_GET = 'MENUWEB_PAGEOPTS_GET';
export const MENUWEB_ADD = 'MENUWEB_ADD';
export const MENUWEB_EDIT = 'MENUWEB_EDIT';
export const MENUWEB_GET = 'MENUWEB_GET';
export const MENUWEB_DELETE = 'MENUWEB_DELETE';
